import { ReactComponent as Battery010 } from './battery0_10.svg';
import { ReactComponent as Battery1120 } from './battery11_20.svg';
import { ReactComponent as Battery2140 } from './battery21_40.svg';
import { ReactComponent as Battery4160 } from './battery41_60.svg';
import { ReactComponent as Battery6180 } from './battery61_80.svg';
import { ReactComponent as Battery81100 } from './battery81_100.svg';

import { ReactComponent as BrdHealth } from './brd_health.svg';
import { ReactComponent as DateIcon } from './dateicon.svg';
import { ReactComponent as DevId } from './devid.svg';
import { ReactComponent as DropDry } from './dropdry.svg';
import { ReactComponent as DropWet } from './dropwet.svg';

import { ReactComponent as FlatSheetGreen } from './flat_sheet_green.svg';
import { ReactComponent as FlatSheetOrange } from './flat_sheet_orange.svg';
import { ReactComponent as FlatSheetRed } from './flat_sheet_red.svg';
import { ReactComponent as FlatSheetYellow } from './flat_sheet_yellow.svg';

import { ReactComponent as LocationPin } from './location_pin.svg';
import { ReactComponent as GPSLock } from './gps_lock.svg';
import { ReactComponent as MovementDetectedIcon } from './movement_detected_icon.svg';
import { ReactComponent as OutletPressure } from './outlet_pressure.svg';
import { ReactComponent as Percentage } from './percentage.svg';
import { ReactComponent as PumpFreq } from './pump_freq.svg';
import { ReactComponent as PumpPower } from './pump_power.svg';
import { ReactComponent as SettingPressure } from './setting_pressure.svg';

import { ReactComponent as SoapDispenserGreen } from './soap_dispenser_green.svg';
import { ReactComponent as SoapDispenserOrange } from './soap_dispenser_orange.svg';
import { ReactComponent as SoapDispenserRed } from './soap_dispenser_red.svg';
import { ReactComponent as SoapDispenserYellow } from './soap_dispenser_yellow.svg';

import { ReactComponent as SoapRollDispenserGreen } from './soap_roll_dispenser_green.svg';
import { ReactComponent as SoapRollDispenserOrange } from './soap_roll_dispenser_orange.svg';
import { ReactComponent as SoapRollDispenserRed } from './soap_roll_dispenser_red.svg';
import { ReactComponent as SoapRollDispenserYellow } from './soap_roll_dispenser_yellow.svg';

import { ReactComponent as StatsIn } from './stats-in.svg';
import { ReactComponent as StatsOut } from './stats-out.svg';
import { ReactComponent as Temperature } from './temperature.svg';
import { ReactComponent as VsdFault } from './vsd_fault.svg';
import { ReactComponent as VsdState } from './vsd_state.svg';
import { ReactComponent as Volume } from './volume.svg';

import dropwet_Dark from './dropwet_Dark.png';
import dropwet_Light from './dropwet_Light.png';
import dropdry_Dark from './dropdry_Dark.png';
import dropdry_Light from './dropdry_Light.png';
// import flat_sheet_green_Light from './flat_sheet_green_Light.png';
// import flat_sheet_orange_Light from './flat_sheet_orange_Light.png';
// import flat_sheet_red_Light from './flat_sheet_red_Light.png';
// import flat_sheet_yellow_Light from './flat_sheet_yellow_Light.png';
import signalbad_Dark from './signalbad_Dark.png';
import signalbad_Light from './signalbad_Light.png';
import signalexcellent_Dark from './signalexcellent_Dark.png';
import signalexcellent_Light from './signalexcellent_Light.png';
import signalgood_Dark from './signalgood_Dark.png';
import signalgood_Light from './signalgood_Light.png';
import signalnone_Dark from './signalnone_Dark.png';
import signalnone_Light from './signalnone_Light.png';
import signalaverage_Dark from './signalaverage_Dark.png';
import signalaverage_Light from './signalaverage_Light.png';
import temperature_Dark from './temperature_Dark.png';
import temperature_Light from './temperature_Light.png';
import volume_Dark from './volume_Dark.png';
import volume_Light from './volume_Light.png';

export const iconMap = {
  gps_lock: GPSLock,
  battery0_10: Battery010,
  battery11_20: Battery1120,
  battery21_40: Battery2140,
  battery41_60: Battery4160,
  battery61_80: Battery6180,
  battery81_100: Battery81100,
  brd_health: BrdHealth,
  dateicon: DateIcon,
  devId: DevId,
  dropdry: DropDry,
  dropwet: DropWet,
  flat_sheet_green: FlatSheetGreen,
  flat_sheet_orange: FlatSheetOrange,
  flat_sheet_red: FlatSheetRed,
  flat_sheet_yellow: FlatSheetYellow,
  location_pin: LocationPin,
  movement_detected_icon: MovementDetectedIcon,
  outlet_pressure: OutletPressure,
  percentage: Percentage,
  pump_freq: PumpFreq,
  pump_power: PumpPower,
  setting_pressure: SettingPressure,
  soap_dispenser_green: SoapDispenserGreen,
  soap_dispenser_orange: SoapDispenserOrange,
  soap_dispenser_red: SoapDispenserRed,
  soap_dispenser_yellow: SoapDispenserYellow,
  soap_roll_dispenser_green: SoapRollDispenserGreen,
  soap_roll_dispenser_orange: SoapRollDispenserOrange,
  soap_roll_dispenser_red: SoapRollDispenserRed,
  soap_roll_dispenser_yellow: SoapRollDispenserYellow,
  stats_in: StatsIn,
  stats_out: StatsOut,
  temperature: Temperature,
  vsd_fault: VsdFault,
  vsd_state: VsdState,
  volume: Volume,
  dropwet_Dark,
  dropwet_Light,
  dropdry_Dark,
  dropdry_Light,
  // flat_sheet_green_Light,
  // flat_sheet_orange_Light,
  // flat_sheet_red_Light,
  // flat_sheet_yellow_Light,
  signalbad_Dark,
  signalbad_Light,
  signalexcellent_Dark,
  signalexcellent_Light,
  signalgood_Dark,
  signalgood_Light,
  signalnone_Dark,
  signalnone_Light,
  signalaverage_Dark,
  signalaverage_Light,
  temperature_Dark,
  temperature_Light,
  volume_Dark,
  volume_Light,
};
